<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-translation`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.83 23.143l5.079 5.302a.335.335 0 010 .46.305.305 0 01-.22.095H44.4C42.158 38.185 33.875 45 24 45S5.842 38.184 3.599 29h4.148C9.882 35.949 16.351 41 24 41c7.648 0 14.117-5.051 16.253-12H37.31a.318.318 0 01-.311-.325c0-.086.033-.169.091-.23l5.079-5.302a.453.453 0 01.66 0zM26.03 15L33 33h-3.97l-2.232-4.968h-5.716L19.032 33H15l7.02-18h4.01zM.311 19H10.69c.082 0 .162.034.22.095a.336.336 0 01.044.4l-.044.06-5.079 5.302a.452.452 0 01-.587.063l-.073-.063-5.079-5.302a.332.332 0 01.149-.546L.31 19H10.69.31zm23.719-.04L22.115 24h3.746l-1.831-5.04zM24 3c9.875 0 18.158 6.816 20.401 16h-4.148C38.118 12.052 31.649 7 24 7 16.352 7 9.883 12.051 7.747 19H3.6C5.842 9.815 14.125 3 24 3z"/></svg>
</template>
<script>

export default {
  name: 'IconTranslation',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
